import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatProgressBarModule} from "@angular/material/progress-bar";
import * as Sentry from '@sentry/angular';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from "@core/core.module";
import {PagesModule} from "@pages/pages.module";
import {LayoutModule} from "@layout/layout.module";
import {OtelNavigationService} from './services/otel-navigation.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    LayoutModule,
    PagesModule,
    MatProgressBarModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    trace: Sentry.TraceService,
    otelNavigation: OtelNavigationService,
  ) {
    // Sentry.TraceService and OtelNavigationService are constructed at startup
    // to subscribe to router events. Neither needs a reference saved.
  }
}
